import { ViewFactory } from 'src/3rds/cube-react'

import { MensagemDiretaScope } from '../MensagemDireta.scopes'
import MensagemDiretaView from './MensagemDireta.view'

export { MensagemDiretaView } from './MensagemDireta.view'

export function registerViews(rv = ViewFactory.register) {
    rv(MensagemDiretaScope, MensagemDiretaView)
}
